import { Link } from 'react-router-dom';
import floorplanToolsHomePage from '../assets/home_page_assets/floorplan-tools-home-page.webp';

function SmartAiDesignHighlightSection() {
  return (
    <section
      id="ai-design-assistance"
      className="why-choose-section container section"
      aria-label="Smart AI design assistance"
    >
      <div className="section-heading">
        <h2>
          <span className="shop-furniture-showcase__title-accent shop-furniture-showcase__title-accent--gradient">
            Smart AI
          </span>
          : From Room Photos to{' '}
          <span className="shop-furniture-showcase__title-accent shop-furniture-showcase__title-accent--gradient">
            Realistic Visuals
          </span>
        </h2>
      </div>

      <div className="why-choose-feature-list">
        <article className="why-choose-feature-card why-choose-feature-card--image-right">
          <div className="why-choose-feature-card__visual" aria-hidden="false">
            <img
              src={floorplanToolsHomePage}
              alt="MyRoomsAI floor plan design tools"
              loading="lazy"
              decoding="async"
            />
          </div>

          <div className="why-choose-feature-card__content">
            <h3 className="why-choose-feature-card__title">Smart AI Design Assistance</h3>
            <p className="why-choose-feature-card__text">
              MyRoomsAI helps turn room photos, sketches, and floor plans into realistic design
              visuals. From decoration ideas to exterior renovation and 3D floor plan views, the AI
              supports the design process and helps users see better options in seconds.
            </p>
            <Link
              to="/ai-tools/ai-room-decoration"
              className="btn btn-primary why-choose-feature-card__cta"
            >
              Try AI Home Design
            </Link>
          </div>
        </article>
      </div>
    </section>
  );
}

export default SmartAiDesignHighlightSection;
